import type { ReactNode } from "react";

import { cn } from "@shared/lib";

export interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  /** Optional small icon slot — kept generic so callers control the visual. */
  icon?: ReactNode;
  /** Optional emphasis tone — used for net-growth deltas (positive/negative). */
  tone?: "neutral" | "positive" | "negative";
  className?: string;
}

const toneClass: Record<NonNullable<MetricCardProps["tone"]>, string> = {
  neutral: "text-foreground",
  positive: "text-emerald-500",
  negative: "text-rose-500",
};

export function MetricCard({
  label,
  value,
  hint,
  icon,
  tone = "neutral",
  className,
}: MetricCardProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 rounded-lg border bg-background p-4",
        className,
      )}
    >
      <div className="flex items-center justify-between text-xs font-medium uppercase tracking-wide text-muted-foreground">
        <span>{label}</span>
        {icon ? <span className="text-muted-foreground">{icon}</span> : null}
      </div>
      <div className={cn("text-2xl font-semibold tabular-nums", toneClass[tone])}>
        {value}
      </div>
      {hint ? (
        <div className="text-xs text-muted-foreground">{hint}</div>
      ) : null}
    </div>
  );
}
